import { render, staticRenderFns } from "./openData.vue?vue&type=template&id=5d5764bb&scoped=true"
import script from "./openData.vue?vue&type=script&lang=js"
export * from "./openData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5764bb",
  null
  
)

export default component.exports